import { render, staticRenderFns } from "./PaymentsCollectionsSvg.vue?vue&type=template&id=bf9f28d6"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports